import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import Monogram from './Monogram';
import Stamp from './Stamp';

const navLinkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'on' : '');

const SiteNav: React.FC = () => {
  const { user, activeRole, roles, logout } = useUser();
  const navigate = useNavigate();

  const isMentorView = !!user && activeRole === 'mentor';

  const handleSignOut = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="nav">
      <div className="wrap">
        <Link className="wordmark" to="/">
          <img src={`${process.env.PUBLIC_URL}/commonroom-logo.png`} alt="Common Room" />
        </Link>

        {isMentorView ? (
          <div className="nav-links">
            <NavLink className={navLinkClass} to="/mentor/dashboard">
              Dashboard
            </NavLink>
            <NavLink className={navLinkClass} to="/mentor/profile">
              Edit profile
            </NavLink>
            <NavLink className={navLinkClass} to="/mentors/me">
              My public profile
            </NavLink>
            <NavLink className={navLinkClass} to="/messages">
              Messages
            </NavLink>
            {user?.isAdmin && (
              <NavLink className={navLinkClass} to="/admin">
                Admin
              </NavLink>
            )}
          </div>
        ) : (
          <div className="nav-links">
            <NavLink className={navLinkClass} to="/mentors" end>
              Mentors
            </NavLink>
            <a href="/#resources">Free resources</a>
            <a href="/#webinars">Webinars</a>
            <NavLink className={navLinkClass} to="/data">
              Data
            </NavLink>
            {user && (
              <>
                <NavLink className={navLinkClass} to="/family-dashboard">
                  Dashboard
                </NavLink>
                <NavLink className={navLinkClass} to="/messages">
                  Messages
                </NavLink>
                {user.isAdmin && (
                  <NavLink className={navLinkClass} to="/admin">
                    Admin
                  </NavLink>
                )}
              </>
            )}
          </div>
        )}

        {user ? (
          <div className="nav-right">
            {isMentorView ? (
              <Stamp variant="verified">Profile live</Stamp>
            ) : (
              <span className="meta">{user.name}</span>
            )}
            {roles.length > 1 && (
              <Link className="btn btn-ghost btn-sm" to="/select-role">
                Switch role
              </Link>
            )}
            <button className="btn btn-ghost btn-sm" onClick={handleSignOut}>
              Sign out
            </button>
            <Link to="/profile" style={{ display: 'inline-flex' }} aria-label="Account">
              <Monogram name={user.name} size={36} />
            </Link>
          </div>
        ) : (
          <div className="nav-right">
            <Link className="btn btn-ghost btn-sm" to="/login">
              Sign in
            </Link>
            <Link className="btn btn-primary btn-sm" to="/mentors">
              Book a mentor
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default SiteNav;
